import { IResource } from "../i18n";

const translation_de_de: IResource = {
    header_title: 'MEET | Reibungslose Interviews',
    header_menu_api: 'API',
    header_signup_text: 'Melde dich kostenlos an',
    header_signin_text: 'Einloggen',
    header_dashboard_text: 'Mein Armaturenbrett',

    general_title_text: 'Reibungslose Interviews',
    general_cta_text_one: 'Sparen Sie Zeit, Geld und Nerven',
    general_cta_text_two: 'bei der Organisation und Durchführung',
    general_cta_text_three: 'Remote-Vorstellungsgespräche',
    general_cta_button: 'Jetzt kostenlos testen',
    general_cta_contact: 'Kontaktieren Sie uns: office@meet.rs',
    general_cta_consent_one: 'Diese Website verwendet Cookies nur zur Analyse und Personalisierung.',
    general_cta_consent_two: 'Durch die weitere Nutzung dieser Website stimmen Sie zu ',
    general_tos_text: 'Nutzungsbedingungen',
    general_tos_tooltip: 'Vivani Nutzungsbedingungen erfüllen',
    general_cookies_text: 'Cookie-Richtlinie',
    general_cookies_tooltip: 'Vivani Meet Cookies-Richtlinie',
    general_privacy_text: 'Datenschutz-Bestimmungen',
    general_privacy_tooltip: 'Vivani Meet Datenschutzerklärung',
    general_refund_text: 'Rückerstattung',
    general_refund_tooltip: 'Vivani Meet Rückerstattung',

    usecase_title_head: 'Speziell für Ferninterviews entwickelt',
    usecase_title_subhead: 'Alles wurde basierend auf den Anforderungen der Personalvermittler und Interviewer von heute entwickelt',
    usecase_interviewer_title: 'INTERVIEWER FREUNDLICH',
    usecase_interviewer_subtitle: 'Aufgabenbibliothek',
    usecase_interviewer_body: 'Richten Sie die Interviewaufgaben im Voraus ein und genießen Sie das Interview',
    usecase_interviewer_learnmore: 'Erfahren Sie mehr ',
    usecase_interviewer_imgalt: 'Whiteboard-Interview',
    usecase_collaboration_title: 'ZUSAMMENARBEITEN',
    usecase_collaboration_subtitle: 'Gebaut für die Zusammenarbeit',
    usecase_collaboration_body_one: 'Anrufen, codieren, zeichnen, schreiben ...',
    usecase_collaboration_body_two: 'Alles zusammen, alles zur selben Zeit.',
    usecase_collaboration_learnmore: 'Erfahren Sie mehr ',
    usecase_collaboration_imgalt: 'Whiteboard-Interview',    
    usecase_recruiter_title: 'Rekrutierer freundlich',
    usecase_recruiter_subtitle: 'Mach deine Arbeit für dich',
    usecase_recruiter_body: 'Automatische Planung, Notizen, Teilnehmererinnerungen, Feedbackerfassung ...',
    usecase_recruiter_learnmore: 'Erfahren Sie mehr',
    usecase_recruiter_imgalt: 'Whiteboard-Interview',    
    usecase_call_title: 'VOLLER HD-GRUPPEN-VIDEOAUFRUF',
    usecase_call_subtitle: 'Mit Aufnahme und Transkription',
    usecase_call_body_one: 'Null Plugins, Apps, Installationen',
    usecase_call_body_two: 'Es funktioniert nur in modernen Browsern!',
    usecase_call_learnmore: 'Erfahren Sie mehr',
    usecase_call_imgalt: 'Whiteboard-Interview',     

    footer_email_text: "Kontaktiere uns",

    signout_menu_text: "Ausloggen",
    me_menu_text: "Mein Treffen",

    help_menu_text: "Hilfe",

    cta_nosignup_text: "Keine Anmeldung oder Download erforderlich.",

    
    // Change language
    language_selector_title: "Sprache",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    general_cta_button_quick: "EIN MEETING VERANSTALTEN",

    general_cta_text_all: "Sparen Sie Zeit, Geld und Nerven bei der Organisation und Durchführung Remote-Vorstellungsgespräche",
    
    header_title_short: "Vivani Meet"
}

export default translation_de_de;